/* Hoggy's Grill home page behaviour: reel, embers, cursor, menu, sliders, scroll moments.
   Everything degrades gracefully: without JS the posters, copy and links still work. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var script = document.currentScript;

  // Run fn once the page has fully loaded, so extras never compete with the first paint.
  function afterLoad(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn, { once: true });
  }

  /* ---------- Reel: films that rotate through the panels ---------- */
  function initReel(reel) {
    var clips = [];
    try { clips = JSON.parse(reel.querySelector('[data-hg-clips]').textContent); } catch (e) { return; }
    var panels = Array.prototype.slice.call(reel.querySelectorAll('[data-hg-panel]'));
    var pauseBtn = reel.querySelector('[data-hg-pause]');
    var mobile = window.matchMedia('(max-width: 749px)');
    var shown = panels.map(function (_, i) { return i % clips.length; });
    var nextClip = panels.length % clips.length;
    var turn = 0, timer = null, paused = false, inView = false, started = false, mediaReady = false;
    var connection = navigator.connection || {};
    // Data saver or a slow connection: keep the still posters and skip the films.
    var lowData = connection.saveData || /2g|3g/.test(connection.effectiveType || '');

    function activePanels() { return mobile.matches ? panels.slice(0, 1) : panels; }
    function videos(panel) { return panel.querySelectorAll('video'); }
    function current(panel) { return panel.querySelector('video:not(.is-hidden)'); }

    function startPanel(panel) {
      var v = current(panel);
      if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }

    function advance() {
      var list = activePanels();
      var panel = list[turn % list.length];
      var idx = panels.indexOf(panel);
      turn++;
      var tries = 0;
      while (shown.indexOf(nextClip) !== -1 && tries < clips.length && list.length < clips.length) {
        nextClip = (nextClip + 1) % clips.length; tries++;
      }
      var clip = clips[nextClip];
      var cur = current(panel);
      var nxt = Array.prototype.filter.call(videos(panel), function (v) { return v !== cur; })[0];
      nxt.poster = clip.poster;
      nxt.src = clip.src;
      var swap = function () {
        nxt.removeEventListener('canplay', swap);
        var p = nxt.play(); if (p && p.catch) p.catch(function () {});
        nxt.classList.remove('is-hidden');
        cur.classList.add('is-hidden');
        setTimeout(function () { cur.pause(); }, 950);
      };
      nxt.addEventListener('canplay', swap);
      nxt.load();
      shown[idx] = nextClip;
      nextClip = (nextClip + 1) % clips.length;
    }

    function play() {
      if (paused || !inView || reduceMotion || !mediaReady) return;
      activePanels().forEach(startPanel);
      started = true;
      if (!timer) timer = setInterval(advance, 6000);
    }
    function stop() {
      clearInterval(timer); timer = null;
      panels.forEach(function (p) { Array.prototype.forEach.call(videos(p), function (v) { v.pause(); }); });
    }

    if (reduceMotion || lowData) { if (pauseBtn) pauseBtn.hidden = true; return; }

    // Films wait until the page has loaded and the first poster is on screen,
    // so the video never competes with the poster for bandwidth.
    function whenMediaReady() {
      var go = function () { if (!mediaReady) { mediaReady = true; play(); } };
      var poster = panels[0] && panels[0].querySelector('img');
      if (!poster || poster.complete) return go();
      poster.addEventListener('load', go, { once: true });
      poster.addEventListener('error', go, { once: true });
    }
    afterLoad(whenMediaReady);

    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      inView ? play() : stop();
    }, { threshold: 0.15 }).observe(reel);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });
    mobile.addEventListener('change', function () { stop(); play(); });

    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', String(paused));
      pauseBtn.setAttribute('aria-label', paused ? 'Play the films' : 'Pause the films');
      // SVG elements have no .hidden property, so toggle the attribute itself.
      pauseBtn.querySelector('[data-icon="pause"]').toggleAttribute('hidden', paused);
      pauseBtn.querySelector('[data-icon="play"]').toggleAttribute('hidden', !paused);
      paused ? stop() : play();
      window.dispatchEvent(new CustomEvent('hg:pause', { detail: paused }));
    });
  }

  /* ---------- Embers: a few warm sparks drifting up the reel ---------- */
  function initEmbers(canvas) {
    if (reduceMotion || !canvas.getContext) return;
    var ctx = canvas.getContext('2d'), sparks = [], raf = null, running = false, w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
    var count = window.innerWidth < 750 ? 22 : 46;
    function size() {
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spark(initial) {
      return {
        x: Math.random() * w, y: initial ? Math.random() * h : h + 10,
        r: 0.6 + Math.random() * 1.8, vy: 0.25 + Math.random() * 0.9, sway: Math.random() * Math.PI * 2,
        life: 0, max: 260 + Math.random() * 260, hue: 18 + Math.random() * 22
      };
    }
    function tick() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < sparks.length; i++) {
        var s = sparks[i];
        s.life++; s.y -= s.vy; s.sway += 0.02; s.x += Math.sin(s.sway) * 0.35;
        var a = Math.max(0, Math.min(1, s.life / 40) * (1 - s.life / s.max)) * 0.85;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = 'hsla(' + s.hue + ', 95%, 55%,' + a + ')'; ctx.fill();
        if (s.life >= s.max || s.y < -10) sparks[i] = spark(false);
      }
      raf = requestAnimationFrame(tick);
    }
    var loaded = false, visible = false, paused = false;
    function start() { if (!running && loaded && visible && !paused && !document.hidden) { running = true; tick(); } }
    function halt() { running = false; cancelAnimationFrame(raf); }
    size(); for (var i = 0; i < count; i++) sparks.push(spark(true));
    window.addEventListener('resize', size);
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; visible ? start() : halt(); }).observe(canvas);
    document.addEventListener('visibilitychange', function () { document.hidden ? halt() : start(); });
    window.addEventListener('hg:pause', function (e) { paused = e.detail; paused ? halt() : start(); });
    afterLoad(function () { loaded = true; start(); });
  }

  /* ---------- "+ Book" bubble over the films (mouse only); the normal pointer stays visible everywhere ---------- */
  function initCursor(zone, cursor) {
    if (!finePointer || !zone || !cursor) return;
    var x = null, y = null;
    zone.addEventListener('pointermove', function (e) {
      // GSAP arrives after page load; until then the label follows the pointer directly.
      if (!x && window.gsap) {
        x = gsap.quickTo(cursor, 'left', { duration: 0.35, ease: 'power3' });
        y = gsap.quickTo(cursor, 'top', { duration: 0.35, ease: 'power3' });
      }
      if (x) { x(e.clientX); y(e.clientY); } else { cursor.style.left = e.clientX + 'px'; cursor.style.top = e.clientY + 'px'; }
    });
    zone.addEventListener('pointerenter', function () { cursor.classList.add('is-on'); });
    zone.addEventListener('pointerleave', function () { cursor.classList.remove('is-on'); });
  }

  /* ---------- Sticky bar: shown once the hero is out of view ---------- */
  function initSticky(bar, reel) {
    if (!bar || !reel || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-on', show);
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' }).observe(reel);
  }

  /* ---------- Horizontal sliders with arrow buttons ---------- */
  function initSliders() {
    document.querySelectorAll('[data-hg-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-hg-track]');
      wrap.querySelectorAll('[data-hg-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: Number(btn.dataset.hgDir) * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* ---------- Scroll moments (the opening sequence is CSS, started by the inline script) ---------- */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initScrollMoments() {
    var rules = document.querySelectorAll('[data-hg-rule]');
    var parallax = document.querySelectorAll('[data-hg-parallax]');
    var clients = document.querySelector('[data-hg-clients]');
    if (reduceMotion || !script || (!rules.length && !parallax.length && !clients)) return;
    afterLoad(function () {
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
      idle(function () {
        loadScript(script.dataset.gsap)
          .then(function () { return loadScript(script.dataset.scrolltrigger); })
          .then(function () {
            gsap.registerPlugin(ScrollTrigger);
            rules.forEach(function (rule) {
              gsap.fromTo(rule, { scaleX: 0 }, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: rule.closest('section'), start: 'top 75%', end: 'bottom 60%', scrub: true } });
            });
            parallax.forEach(function (img) {
              gsap.fromTo(img, { yPercent: -6, scale: 1.12 }, { yPercent: 6, scale: 1.12, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
            });
            if (clients) initClients(clients);
          })
          .catch(function () {});
      });
    });
  }

  /* ---------- Clients: each batch of names that scrolls into view flips the patty ---------- */
  function initClients(section) {
    var names = Array.prototype.slice.call(section.querySelectorAll('[data-hg-names] li'));
    var patty = section.querySelector('.hg-patty');
    var sparks = section.querySelector('.hg-grill__sparks');
    if (!names.length || !patty) return;
    var side = 1, busy = false;

    function burst() {
      if (!sparks) return;
      for (var i = 0; i < 12; i++) {
        var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('cx', 200 + (Math.random() * 160 - 80));
        c.setAttribute('cy', 214);
        c.setAttribute('r', 1.5 + Math.random() * 2.5);
        sparks.appendChild(c);
        gsap.to(c, {
          x: Math.random() * 160 - 80, y: -60 - Math.random() * 120, opacity: 0,
          duration: 0.8 + Math.random() * 0.7, ease: 'power2.out',
          onComplete: (function (el) { return function () { el.remove(); }; })(c)
        });
      }
    }
    function flip() {
      if (busy) return;
      busy = true;
      side = -side;
      gsap.timeline({ onComplete: function () { busy = false; } })
        .to(patty, { y: -120, duration: 0.32, ease: 'power2.out' }, 0)
        .to(patty, { scaleY: side, rotation: side > 0 ? 0 : 4, duration: 0.5, ease: 'power1.inOut' }, 0)
        .to(patty, { y: 0, duration: 0.3, ease: 'power2.in' }, 0.32)
        .add(burst, 0.62)
        .to(patty, { scaleX: 1.07, duration: 0.08, yoyo: true, repeat: 1, ease: 'power1.out' }, 0.62);
    }

    gsap.set(patty, { transformOrigin: '50% 50%' });
    section.classList.add('is-animated');
    ScrollTrigger.batch(names, {
      start: 'top 92%',
      once: true,
      onEnter: function (batch) {
        gsap.to(batch, { opacity: 1, y: 0, duration: 0.6, ease: 'back.out(2)', stagger: 0.07 });
        flip();
      }
    });
    // Names the visitor has already scrolled past show straight away.
    names.forEach(function (li) { if (li.getBoundingClientRect().bottom < 0) gsap.set(li, { opacity: 1, y: 0 }); });
  }

  /* ---------- Find us: a dark 3D map that loads only when it's nearly on screen ---------- */
  function initMap(el) {
    if (!el || !('IntersectionObserver' in window)) return;
    var lat = Number(el.dataset.lat), lng = Number(el.dataset.lng);
    var near = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      near.disconnect();
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = el.dataset.css;
      document.head.appendChild(css);
      Promise.all([loadScript(el.dataset.js), fetch(el.dataset.style).then(function (r) { return r.json(); })])
        .then(function (res) { build(restyle(res[1])); })
        .catch(function () {});
    }, { rootMargin: '600px 0px' });
    near.observe(el);

    // Recolour the OpenFreeMap "dark" style in the brand palette and raise the buildings into 3D.
    function restyle(style) {
      var colours = {
        background: '#151311', water: '#1b2326', landuse_residential: '#1a1816',
        landcover_wood: '#19201a', landuse_park: '#1b221b'
      };
      style.layers = style.layers.map(function (layer) {
        var id = layer.id;
        layer.paint = layer.paint || {};
        if (id === 'background') layer.paint['background-color'] = colours.background;
        else if (colours[id] && layer.type === 'fill') { delete layer.paint['fill-pattern']; layer.paint['fill-color'] = colours[id]; }
        else if (id === 'waterway') layer.paint['line-color'] = '#1f2b2f';
        else if (id === 'building') {
          return {
            id: 'building-3d', type: 'fill-extrusion', source: layer.source, 'source-layer': 'building', minzoom: 13,
            paint: {
              'fill-extrusion-color': '#2b2622',
              'fill-extrusion-height': ['coalesce', ['get', 'render_height'], 6],
              'fill-extrusion-base': ['coalesce', ['get', 'render_min_height'], 0],
              'fill-extrusion-opacity': 0.94
            }
          };
        }
        else if (layer.type === 'line' && /highway_(major|motorway)_inner/.test(id)) layer.paint['line-color'] = '#5a4636';
        else if (layer.type === 'line' && /casing/.test(id)) layer.paint['line-color'] = '#1c1916';
        else if (layer.type === 'line' && /highway_(minor|path)/.test(id)) layer.paint['line-color'] = '#332c27';
        else if (layer.type === 'line' && /railway/.test(id)) layer.paint['line-color'] = '#3a3430';
        else if (layer.type === 'symbol') {
          if (/oneway/.test(id)) { layer.layout = layer.layout || {}; layer.layout.visibility = 'none'; }
          layer.paint['text-color'] = '#cfc6b8';
          layer.paint['text-halo-color'] = '#101010';
        }
        return layer;
      });
      return style;
    }

    function build(style) {
      var map = new maplibregl.Map({
        container: el.querySelector('[data-hg-map-canvas]'),
        style: style,
        center: [lng, lat], zoom: 12, pitch: 0, bearing: 0,
        cooperativeGestures: true,
        attributionControl: { compact: true }
      });
      map.addControl(new maplibregl.NavigationControl({ visualizePitch: true }), 'top-right');
      var pin = document.createElement('div');
      pin.className = 'hg-pin';
      pin.innerHTML = '<span><img src="' + el.dataset.logo + '" alt="" width="22" height="33"></span>';
      new maplibregl.Marker({ element: pin }).setLngLat([lng, lat]).addTo(map);

      map.on('load', function () {
        el.classList.add('is-ready');
        var seen = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          seen.disconnect();
          map.flyTo({ center: [lng, lat], zoom: 16.8, pitch: 62, bearing: -28, duration: reduceMotion ? 0 : 5200, curve: 1.3, essential: true });
          if (reduceMotion) return;
          // A slow orbit once it lands, until the visitor takes over.
          var orbiting = true;
          var stop = function () { orbiting = false; };
          ['mousedown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { el.addEventListener(ev, stop, { once: true, passive: true }); });
          map.once('moveend', function orbit() {
            if (!orbiting) return;
            map.easeTo({ bearing: map.getBearing() + 40, duration: 24000, easing: function (t) { return t; } });
            map.once('moveend', orbit);
          });
        }, { threshold: 0.35 });
        seen.observe(el);
      });
    }
  }

  function init() {
    var reel = document.querySelector('[data-hg-reel]');
    if (reel) {
      initReel(reel);
      initEmbers(reel.querySelector('[data-hg-embers]'));
      initCursor(reel.querySelector('[data-hg-cursor-zone]'), document.querySelector('[data-hg-cursor]'));
    }
    initSticky(document.querySelector('[data-hg-sticky]'), reel);
    initSliders();
    initScrollMoments();
    initMap(document.querySelector('[data-hg-map]'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
